// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%23e2e8f0%27 height=%2720%27 viewBox=%270 0 20 20%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M5 7l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.add-btn {
  background: #facc15;
  color: #020617;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.add-btn:hover {
  background: #fde047;
}

.article-table {
  width: 100%;
  border-collapse: collapse;
  background: #020617;
  border-radius: 12px;
  overflow: hidden;
}

.article-table th {
  background: #1e293b;
  padding: 14px;
  text-align: left;
}

.article-table td {
  padding: 14px;
  border-top: 1px solid #1e293b;
}

.article-table tr:hover {
  background: #1a2333;
}

.action-icons {
  display: flex;
  gap: 8px;
}

.icon-btn {
  background: #1e293b;
  border: none;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  color: white;
}

.icon-btn:hover {
  background: #334155;
}

.icon-btn.delete:hover {
  background: #ef4444;
}
.search-input {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  width: 250px;
  font-size: 14px;
}

.status-pill {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  text-transform: capitalize;
}

.status-pill.active {
  background: #d1fae5;
  color: #065f46;
}

.status-pill.inactive {
  background: #fee2e2;
  color: #991b1b;
}

/* Modal same as category */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 400px;
}

.details-table td {
  padding: 8px 0;
}

/* Status Button */
.status-btn {
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

/* Active */
.status-btn.active {
  background: #22c55e;
  color: #022c22;
}

.status-btn.active:hover {
  background: #16a34a;
}

/* Inactive */
.status-btn.inactive {
  background: #ef4444;
  color: #fff;
}

.status-btn.inactive:hover {
  background: #dc2626;
}

/* Button Group */
.button-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Download Template Button */
.download-template-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.download-template-btn:hover {
  background-color: #45a049;
}

/* Upload Button */
.upload-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #2196f3;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.upload-btn:hover {
  background-color: #0b7dda;
}

/* Upload Modal Styles */
.upload-modal {
  max-width: 500px;
  width: 90%;
}

.upload-instructions {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  margin: 20px 0;
}

.upload-instructions ol {
  margin: 10px 0;
  padding-left: 20px;
}

.upload-instructions li {
  margin: 5px 0;
  color: #495057;
}

.upload-instructions .note {
  margin-top: 10px;
  font-size: 12px;
  color: #856404;
  background-color: #fff3cd;
  padding: 8px;
  border-radius: 4px;
}

.file-upload-area {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
}

.select-file-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.select-file-btn:hover {
  background-color: #5a6268;
}

.selected-file-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #e3f2fd;
  border-radius: 4px;
  font-size: 14px;
}

.clear-file-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #dc3545;
  padding: 0 5px;
}

.clear-file-btn:hover {
  color: #c82333;
}

.modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

.upload-submit-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.upload-submit-btn:disabled {
  background-color: #facc15;
  cursor: not-allowed;
}

.cancel-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-btn:hover {
  background-color: #c82333;
}
.center_modal_class {

    align-items: center !important;

}
.filter-select {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #334155;
  font-size: 14px;

  background-color: #0f172a;   /* same as table bg */
  color: #e2e8f0;

  height: 38px;                /* same as search */
  min-width: 140px;            /* width kam */
  outline: none;

  appearance: none;            /* remove default arrow style */
  cursor: pointer;
}

/* dropdown arrow custom */
.filter-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
}

/* focus effect */
.filter-select:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 1px #facc15;
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .button-group {
    flex-wrap: wrap;
  }
  
  .download-template-btn,
  .upload-btn,
  .add-btn {
    font-size: 12px;
    padding: 6px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Article Master/ArticleList/ArticleList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;IAEI,8BAA8B;;AAElC;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;;EAEf,yBAAyB,IAAI,qBAAqB;EAClD,cAAc;;EAEd,YAAY,iBAAiB,mBAAmB;EAChD,gBAAgB,aAAa,cAAc;EAC3C,aAAa;;EAEb,gBAAgB,aAAa,+BAA+B;EAC5D,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,yDAAoL;EACpL,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".header-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.add-btn {\n  background: #facc15;\n  color: #020617;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.add-btn:hover {\n  background: #fde047;\n}\n\n.article-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #020617;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.article-table th {\n  background: #1e293b;\n  padding: 14px;\n  text-align: left;\n}\n\n.article-table td {\n  padding: 14px;\n  border-top: 1px solid #1e293b;\n}\n\n.article-table tr:hover {\n  background: #1a2333;\n}\n\n.action-icons {\n  display: flex;\n  gap: 8px;\n}\n\n.icon-btn {\n  background: #1e293b;\n  border: none;\n  padding: 6px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: white;\n}\n\n.icon-btn:hover {\n  background: #334155;\n}\n\n.icon-btn.delete:hover {\n  background: #ef4444;\n}\n.search-input {\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  width: 250px;\n  font-size: 14px;\n}\n\n.status-pill {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.status-pill.active {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-pill.inactive {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Modal same as category */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 25px;\n  border-radius: 12px;\n  width: 400px;\n}\n\n.details-table td {\n  padding: 8px 0;\n}\n\n/* Status Button */\n.status-btn {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n/* Active */\n.status-btn.active {\n  background: #22c55e;\n  color: #022c22;\n}\n\n.status-btn.active:hover {\n  background: #16a34a;\n}\n\n/* Inactive */\n.status-btn.inactive {\n  background: #ef4444;\n  color: #fff;\n}\n\n.status-btn.inactive:hover {\n  background: #dc2626;\n}\n\n/* Button Group */\n.button-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Download Template Button */\n.download-template-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.download-template-btn:hover {\n  background-color: #45a049;\n}\n\n/* Upload Button */\n.upload-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #2196f3;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.upload-btn:hover {\n  background-color: #0b7dda;\n}\n\n/* Upload Modal Styles */\n.upload-modal {\n  max-width: 500px;\n  width: 90%;\n}\n\n.upload-instructions {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 6px;\n  margin: 20px 0;\n}\n\n.upload-instructions ol {\n  margin: 10px 0;\n  padding-left: 20px;\n}\n\n.upload-instructions li {\n  margin: 5px 0;\n  color: #495057;\n}\n\n.upload-instructions .note {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #856404;\n  background-color: #fff3cd;\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.file-upload-area {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.select-file-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.select-file-btn:hover {\n  background-color: #5a6268;\n}\n\n.selected-file-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background-color: #e3f2fd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.clear-file-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #dc3545;\n  padding: 0 5px;\n}\n\n.clear-file-btn:hover {\n  color: #c82333;\n}\n\n.modal-buttons {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.upload-submit-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.upload-submit-btn:disabled {\n  background-color: #facc15;\n  cursor: not-allowed;\n}\n\n.cancel-btn {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancel-btn:hover {\n  background-color: #c82333;\n}\n.center_modal_class {\n\n    align-items: center !important;\n\n}\n.filter-select {\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid #334155;\n  font-size: 14px;\n\n  background-color: #0f172a;   /* same as table bg */\n  color: #e2e8f0;\n\n  height: 38px;                /* same as search */\n  min-width: 140px;            /* width kam */\n  outline: none;\n\n  appearance: none;            /* remove default arrow style */\n  cursor: pointer;\n}\n\n/* dropdown arrow custom */\n.filter-select {\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='%23e2e8f0' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M5 7l5 5 5-5z'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n}\n\n/* focus effect */\n.filter-select:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 1px #facc15;\n}\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .button-group {\n    flex-wrap: wrap;\n  }\n  \n  .download-template-btn,\n  .upload-btn,\n  .add-btn {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
